import { cache_app_requests, cache_chunk_requests } from "../config.js";
import { IS_BROWSER, IS_WEB } from "../consts.js";
import { IndexedDBAppService } from "./IndexedDB/IndexedDBAppService.js";
import { IndexedDBChunkService } from "./IndexedDB/IndexedDBChunkService.js";
import { appsConf } from "./IndexedDB/appDataConf.js";
import { chunksConf } from "./IndexedDB/chunkDataConf.js";
import { AppHttpService } from "./httpService/AppHttpService.js";
import { ChunkHttpService } from "./httpService/ChunkHttpService.js";


import "./IndexedDB/init.js";


//TODO confs should be used only for appropriate classes therefore it doesnt make sense to export them here

let AppDataService;
let ChunkDataService;

let appDataServiceConf;
let chunkDataServiceConf;


if (
    IS_BROWSER &&
    cache_chunk_requests
) {
    ChunkDataService = IndexedDBChunkService;
    chunkDataServiceConf = chunksConf;

} else {
    ChunkDataService = ChunkHttpService;
}


if (
    IS_BROWSER &&
    cache_app_requests // todo here outdated approach
) {
    AppDataService = IndexedDBAppService; // here will be AppHttpService for browser too, check compatability. Checked. seems different code. IndexedDBAppService uses worker
    appDataServiceConf = appsConf;
} else {
    AppDataService = AppHttpService;
}


export {
    AppDataService,
    ChunkDataService,
    appDataServiceConf,
    chunkDataServiceConf,
};